<template>
    <div>
        <div class="card">
            <Toolbar class="mb-4">
                <template slot="left">
                    <label>ELIMINAR FACTURA DE CLIENTES</label>
                </template>
            </Toolbar>
			<br>
			<DataTable
                class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                :value="dataClientes"
                :rowHover="true"
                dataKey="id"
                :paginator="true"
                :rows="100"
                :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                <template #header>
                    <div class="table-header">
                        <h5 class="p-m-0"> Clientes  </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filters['global']" placeholder="Buscar..." />
                        </span>
                    </div>
                </template>
                <template #empty> No se encontraron Registros. </template>
                <template #loading> Cargando Registros, por favor espere un momento. </template>
                <Column field="cedula" header="Cédula" headerStyle="width: 9em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Cédula:</span>
                        {{ slotProps.data.cedula }}
                    </template>
                </Column>
                <Column field="nombres" header="Nombres">
                    <template #body="slotProps">
                        <span class="p-column-title"> Nombres:</span>
                        <span  :class="'customer-badge'">{{slotProps.data.nombres}} </span>
                    </template>
                </Column>
				<Column field="apellidos" header="Apellidos">
                    <template #body="slotProps">
                        <span class="p-column-title"> Apellidos:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.apellidos }} </span>
                    </template>
                </Column>
                <Column field="numeromedidor" header="No. Medidor" headerStyle="width: 15em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> No. Medidor:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.numeromedidor }} </span>
                    </template>
                </Column>
                <Column headerStyle="width: 7em;">
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" v-tooltip="'Ver Facturas del cliente'" @click="verFacturas(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>
        </div>
		<Dialog :visible.sync="facturasDialog" :style="{ width: '700px' }" :header="textocliente" :modal="true" class="p-fluid" :position="position" @hide="cerrarDialogo()">
			<div class="col-md-12 p-lg-12">
				<DataTable
					class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
					:value="dataFactura"
					:rowHover="true"
					dataKey="id"
					:paginator="true"
					:rows="5"
					paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
					currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
					<template #empty> No hay planillas pendientes. </template>
					<template #loading> Cargando Registros, por favor espere un momento. </template>
					<Column field="id" header="No. comprobante" >
						<template #body="slotProps">
							<span class="p-column-title"> No. comprobante:</span>
							{{ slotProps.data.id }}
						</template>
					</Column>
					<Column field="fechaemision" header="Fecha emisión">
						<template #body="slotProps">
							<span class="p-column-title"> Fecha emisión:</span>
							<span  :class="'customer-badge'">{{ slotProps.data.fechaemision }} </span>
						</template>
					</Column>
					<Column field="totalpagado" header="Valor pagado">
						<template #body="slotProps">
							<span class="p-column-title"> Valor pagado:</span>
							<span  :class="'customer-badge'">{{ slotProps.data.totalpagado }} </span>
						</template>
					</Column>
					<Column headerStyle="width: 7em;">
						<template #body="slotProps">
							<Button icon="pi pi-file-pdf" class="p-button-rounded p-button-success p-mr-2" v-tooltip="'Imprimir factura'" @click="imprimirFactura(slotProps.data)" />
							<Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2" v-tooltip="'Eliminar factura'" @click="eliminarFactura(slotProps.data)" />
						</template>
					</Column>
				</DataTable>
			</div>
			<template #footer>
				<Button label="Salir" icon="pi pi-times" class="p-button-warning p-mr-2" @click="cerrarDialogo()" />
			</template>
		</Dialog>
		<DialogProgreso
            :showProgreso="showProgreso"
            :titulo="mensajeCargando">
        </DialogProgreso>
	</div>
</template>
<script>
import ClienteService from "../../service/administracion/ClienteService";
import FacturaService from "../../service/administracion/FacturaService";
import Swal from 'sweetalert2';
import Globals from "../../js/Globales";
import DialogProgreso from "../componentesglobales/DialogoProgreso.vue";

export default {
	data() {
		return {
			dataClientes: [],
			filters: {},
			position: "top",
			rango: Globals[0].paginacion.rango,
			disbleClientes: false,
			showProgreso: null,
            mensajeCargando: null,
			facturasDialog: false,
			textocliente: null,

			dataFactura: []
		}
	},
	clienteService: null,
	facturaService: null,
	created() {
		this.clienteService = new ClienteService();
		this.facturaService = new FacturaService();
	},
	mounted() {
        this.consultarClientes();
	},
	components: {
		'DialogProgreso': DialogProgreso
	},
	methods: {
		consultarClientes(){
			this.dataClientes = [];
			Swal.fire({
                title: 'Cargando...',
                html: 'por favor, espere!...',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
			this.clienteService.consultarClientes().then( response => {
				Swal.close();
				this.dataClientes = response.data;
				this.disbleClientes = true;
				this.showProgreso = false;
			}).catch( error => {
				Swal.close();
				console.log(error);
			});
		},

		verFacturas(data){
			this.facturasDialog = true;
			Swal.fire({
                title: 'Cargando...',
                html: 'por favor, espere!...',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
			this.dataFactura = [];
			this.textocliente = "Facturas generadas - " + data.nombres + " " + data.apellidos;
			this.facturaService.consultarFacturaCliente( data.id ).then( response => {
				Swal.close();
				this.dataFactura = response.data.data;
				this.textocliente = this.textocliente + ", Total planillas: " + this.dataFactura.length;
			}).catch( error => {
				Swal.close();
				console.log(error);
			});
		},

		eliminarFactura(data){
			Swal.fire({ title: 'Advertencia', text: "Desea Eliminar el Registro?", icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Si', cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.facturaService.eliminarFacturaPorId(data.id).then( response => {
                        let res = response.data;
						console.log(res);
						if(res.estado === "ok"){
							console.log("graba correcto")
							Swal.fire({ position: 'center', title: 'Correcto!', text: "Eliminado correctamente", icon: 'success', showConfirmButton: true, timer: 6000 });
							this.eliminarElementoLista(data.id);
						}else{
							Swal.fire({ position: 'center', title: 'Advertencia!', text: "" + res.mensaje + "", icon: 'warning', showConfirmButton: true, timer: 6000 });
						}
                    }).catch((err) => {
						console.log(err)
                        Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al eliminar", icon: 'warning', showConfirmButton: true, timer: 6000 });
                    });
                }
            })
		},

		imprimirFactura( data ){
			console.log( data )
			this.mensajeCargando = "Generando planilla";
            this.showProgreso = true;
			this.facturaService.imprimirFactura( data.id ).then(response => {
                var headers = response.headers;
                var blob = new Blob([response.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "Factura-" + data.id + "-" + data.cedula;
                link.click();
				this.showProgreso = false;
            })
            .catch(() => {
            });
		},

		cerrarDialogo(){
			this.planillasDialog = false;
			this.dataPlanilla = [];
		},

		eliminarElementoLista(id){
			var ideliminar = null;
			for(let i = 0 ; i < this.dataFactura.length ; i++){
				if(this.dataFactura[i].id == id){
					ideliminar = i;
				}
			}
			this.dataFactura.splice(ideliminar, 1);
		}
	}
}
</script>
<style scoped lang="scss">
/deep/ .p-progressbar {
	height: .5rem;
	background-color: #D8DADC;
	.p-progressbar-value {
		background-color: #607D8B;
	}
}
.table-header {
	display: flex;
	justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-customers {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}
	.p-paginator {
		padding: 1rem;
	}
	.p-datatable-thead > tr > th {
		text-align: left;
	}
	.p-datatable-tbody > tr > td {
		cursor: auto;
	}
	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}
/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    display: none;
    
    
}
.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-qualified {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-0 {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-negotiation {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.status-1 {
		background: #B3E5FC;
		color: #23547B;
	}
	&.status-renewal {
		background: #ECCFFF;
		color: #694382;
	}
	&.status-proposal {
		background: #FFD8B2;
		color: #805B36;
	}
}
.p-progressbar-value.ui-widget-header {
	background: #607d8b;
}
@media (max-width: 640px) {
	.p-progressbar {
		margin-top: .5rem;
	}
}
.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}
.orders-subtable {
	padding: 1rem;
}
.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}
.order-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.order-delivered {
		background: #C8E6C9;
		color: #256029;
	}
	&.order-cancelled {
		background: #FFCDD2;
		color: #C63737;
	}
	&.order-pending {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.order-returned {
		background: #ECCFFF;
		color: #694382;
	}
}

@media screen and (max-width: 960px) {
	/deep/ .p-datatable {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}
			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;
					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}
					.p-progressbar {
						margin-top: .5rem;
					}
				}
			}
		}
	}
}
</style>